import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { TicketReturnContext } from "../../aiTickets.types";
import { ApiRoutesSupportTickets } from "../../constants/enums";

export const requestTicketReturnContext = async (
  ticketId: string,
): Promise<TicketReturnContext> => {
  return await instance.get(
    buildUrl(ApiRoutesSupportTickets.Tickets, ticketId, "return-context"),
  );
};
